import { FC } from 'react';

export const Error: FC = () => (
  <div>Something went wrong, please refresh this page</div>
);
